// CASOSDETALLES requests
export const CASOSDETALLES_LIST = "CASOSDETALLES_LIST";
export const CASOSDETALLES_LISTA = "CASOSDETALLES_LISTA";
export const CASOSDETALLES_CREATE = "CASOSDETALLES_CREATE";
export const CASOSDETALLES_FILTER = "CASOSDETALLES_FILTER";
export const CASOSDETALLES_UPDATE = "CASOSDETALLES_UPDATE";
export const CASOSDETALLES_DELETE = "CASOSDETALLES_DELETE";
export const CASOSDETALLES_READ = "CASOSDETALLES_READ";

// CASOSDETALLES success
export const CASOSDETALLES_LIST_SUCCESS = "CASOSDETALLES_LIST_SUCCESS";
export const CASOSDETALLES_CREATE_SUCCESS = "CASOSDETALLES_CREATE_SUCCESS";
export const CASOSDETALLES_UPDATE_SUCCESS = "CASOSDETALLES_UPDATE_SUCCESS";
export const CASOSDETALLES_DELETE_SUCCESS = "CASOSDETALLES_DELETE_SUCCESS";
export const CASOSDETALLES_READ_SUCCESS = "CASOSDETALLES_READ_SUCCESS";

// CASOSDETALLES failed
export const CASOSDETALLES_REQUEST_FAILED = "CASOSDETALLES_REQUEST_FAILED";
